class LoginPage extends HTMLElement {
  constructor() {
    super();

    this.contentBlocks = this.querySelectorAll('[data-login-page-content]');
    this.contentToggles = this.querySelectorAll('[data-login-page-toggle]');

    if (this.contentToggles) {
      this.contentToggles.forEach((contentToggle) => {
        contentToggle.addEventListener('click', this.toggleContent.bind(this));
      });
    }

    if (window.location.href.indexOf('#recover') === -1) { return; }

    this.toggleContent(null, 'recover');
  }

  toggleContent(event, target) {
    const targetBlock = event ? event.target.getAttribute('data-login-page-toggle') : target;

    this.contentBlocks.forEach((contentBlock) => {
      if (contentBlock.getAttribute('data-login-page-content') === targetBlock) {
        contentBlock.classList.remove('d-none');
      } else {
        contentBlock.classList.add('d-none');
      }
    });
  }
}

customElements.define('login-page', LoginPage);
